import { Component, Renderer2, ViewChild } from '@angular/core';
import { Alert, Nav, Platform } from 'ionic-angular';
import { Keyboard } from '@ionic-native/keyboard';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from "../services/auth.service";
import { EventService } from "../services/event.service";
import { MobileSidebar } from "../partials/mobile-sidebar/mobile-sidebar";
import { TabBar } from "../partials/tab-bar/tab-bar";
import { NavigationHelper } from "../helpers/navigation.helper";
import { Search } from "../components/search/search";
import { Dashboard } from "../components/dashboard/dashboard";
import { SearchService } from "../services/search.service";
import { NotificationService } from "../services/notification.service";
import { Subscription } from "rxjs/Subscription";
import { PageTitleService } from "../services/page-title.service";
import { Network } from "@ionic-native/network";
import { IonicHelper } from "../helpers/ionic.helper";
import { UserGroupService } from "../services/user-group.service";
import { CategoryService } from "../services/category.service";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { merge } from "rxjs/observable/merge";
import { mapTo } from "rxjs/operators";


@Component({
  template: `
  <div class="apploader" *ngIf="loading">
    <ion-spinner class="app-loader"></ion-spinner>    
  </div>
  
  <header-bar *ngIf="authService.user && !ionic.isMobile"></header-bar>
  
  <ion-nav #rootNav id="rootNav" name="rootNav" [ngClass]="{
  'withTabBar':(ionic.isMobile),
  'withKeyboard': (ionic.keyboardShown$|async)
  }" [swipeBackEnabled]="swipeBackEnabled"></ion-nav>
  
  <ng-template [ngIf]="authService.user && ionic.isMobile">
    <tab-bar #tabBar  [mobileSidebarActive]="showMobileSidebar"></tab-bar>
    <mobile-sidebar #mobileSidebar [show]="showMobileSidebar"></mobile-sidebar>  
  </ng-template>
  <feedback-modal [show]="showFeedbackForm"></feedback-modal>
  `,
})
export class Cas {

  @ViewChild('rootNav') nav: Nav;
	@ViewChild('tabBar') tabBar: TabBar;
	@ViewChild('mobileSidebar') mobileSidebar: MobileSidebar;

  private showTabBar: boolean = true;
  public showMobileSidebar: boolean = false;

  private disconnectedAlert: Alert;

  public loading: boolean = true;

  public showFeedbackForm: boolean = false;

  swipeBackEnabled: boolean = false;
  firstViewDidEnterSubscription: Subscription;
  firstLoadConnectionSubscription: Subscription;
  

  constructor(private platform: Platform,
              statusBar: StatusBar,
              splashScreen: SplashScreen,
              translate: TranslateService,
              public authService: AuthService,
							public eventService: EventService,
              private domRenderer: Renderer2,
							private navigationHelper: NavigationHelper,
              private searchService: SearchService,
              private notificationService: NotificationService,
              private pageTitleService: PageTitleService,
              private userGroupService: UserGroupService,
              private categoryService: CategoryService,
              private keyboard: Keyboard,
              private network: Network,
              public ionic: IonicHelper
              ) {


    translate.setDefaultLang('nl');

    // console.log(platform.platforms());

    authService.userLogin.subscribe(() => {

      // Init notifications
      platform.ready().then(() => {
        this.notificationService.init(platform);
      });

      // Load usergroups
      this.userGroupService.loadUserGroups();

      // Load categories
      this.categoryService.loadCategories();

    });


    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      if(platform.is('ios')){
        this.swipeBackEnabled = true;
      }

      if(this.network.type==='none'){
        this.disconnectedAlert = this.ionic.uncloseableAlert('GLOBAL.ERRORS.NO_NETWORK', 'GLOBAL.OOPS');
        this.firstLoadConnectionSubscription = this.network.onConnect().subscribe(()=> {
          authService.initialize();
          this.firstLoadConnectionSubscription.unsubscribe();
        })
      }
      else {
        authService.initialize();
      }

      platform.resume.subscribe(() => {
        this.eventService.appResume.emit();
        this.eventService.reloadPosts.emit();
      });
    });
    
    const keyboardShownSub = this.ionic.keyboardShown$
      .subscribe(shown => {
        console.log(shown ? 'Keyboard SHOW':'keyboard HIDE');
      });
    
    eventService.componentActivated.subscribe(()=>{
      this.keyboard.hide();
    });

    eventService.toggleKeyboard.subscribe((show)=>{
        if(show) this.keyboard.show();
        else this.keyboard.hide();
    });

    eventService.gotoNewPost.subscribe(() => {
			if(this.navigationHelper.activeComponentIs('Dashboard')){
    		eventService.showNewPostDialog.emit();
			}
			else {
    		this.nav.setRoot('dashboard').then(()=>{
					eventService.showNewPostDialog.emit();
				});
			}
		});

    notificationService.onPrepend.subscribe(()=>{
      this.eventService.reloadPosts.emit();
    });
    notificationService.onUnreadChanged.subscribe(()=>{
      let numUnreadNotifications = this.notificationService.unreadNotificationCount;
      let pageTitlePrefix = (numUnreadNotifications > 0) ? '('+numUnreadNotifications+')' : null;
      this.pageTitleService.setPageTitlePrefix(pageTitlePrefix);
    });



    this.eventService.doSearch.subscribe((searchTerm) => {

      if(this.navigationHelper.activeComponentIs('Search')) {
        this.searchService.setSearchTerm(searchTerm, 'doSearchEvent');
        this.navigationHelper.updateLocation(null, 'search', { searchTerm: searchTerm }, 'switch');
      }
      else {
        this.navigationHelper.pushWithLocationUpdate(null, 'search', { searchTerm: searchTerm });
      }

    });

    // eventService.apiLoading.subscribe((loadingInfo: ApiLoadingInfo)=> {
    //   if(loadingInfo.loading) {
    //     if(loadingInfo.method!=='updateResource') this.domRenderer.addClass(document.body, 'api-loading');
    //   }
    //   else {
    //     //Wait for components to render
    //     setTimeout(()=> {
    //       this.domRenderer.removeClass(document.body, 'api-loading');
    //     },50);
    //   }
    // });

    authService.userLogout.subscribe(()=> {
      if(this.nav.getActive()){
        if(this.nav.getActive().component.loginRequired) {
          this.nav.setRoot('login');
        }
      }
    });

		this.eventService.toggleMobileSidebar.subscribe((show) => {
      if(show === undefined) show = (!this.showMobileSidebar);
      this.showMobileSidebar = show;
      this.eventService.mobileSidebarToggled.emit(show);
		});

		this.eventService.toggleFeedbackForm.subscribe(show => this.showFeedbackForm = show);

		let disconnectSubscription = this.network.onDisconnect().subscribe(() => {
		  if(!this.disconnectedAlert) this.disconnectedAlert = this.ionic.uncloseableAlert('GLOBAL.ERRORS.NO_NETWORK', 'GLOBAL.OOPS');
    });

		let connectSubscription = this.network.onConnect().subscribe(() => {
      if(this.disconnectedAlert) {
        this.disconnectedAlert.dismiss().then(()=>{
          this.disconnectedAlert = null;
        })
      }
    });

  }

  ngOnInit(): void {

    this.firstViewDidEnterSubscription = this.nav.viewDidEnter.subscribe(()=>{
        this.firstViewDidEnterSubscription.unsubscribe();
        this.eventService.appLoaded.emit();
        this.loading=false;
    });

    if(this.navigationHelper.currentPath === ''){//On load
      if(!this.nav.getActive()) {
        this.authService.isLoggedIn().then((loggedIn) => {
          //Todo, do better!
          if(loggedIn) {
            location.href = '/#/dashboard/meest-recent';
          } else {
            location.href = '/#/inloggen';
          }
          // this.nav.setRoot(loggedIn ? 'dashboard':'login')
        });
      }
    }

  }


}




// WEBPACK FOOTER //
// ./src/app/app.component.ts